import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function EstimatedTradeCostHelp() {
    return (
        <IconTooltip>
            <div>
                This widget provides Total Cost and Current Risk for an order
                selection. Both are expressed in basis points.{' '}
            </div>
            <div>
                The widget uses our MAS Optimiser to estimate impact and risk
                for a given quantity (including any constraints), based on a
                combination of benchmark and profile chosen by the user. An
                optimal end time is also returned.{' '}
            </div>
            <div>
                The benchmark and profile, along with other parameters such as
                Lit Participation and Strike Time, can be set in the widget
                configuration.
            </div>
        </IconTooltip>
    );
}
